import Vue from "vue";
const base = "/api";
const url = "https://static0.xesimg.com/talcode/keyboard/keyboard.json";
import { fnDoShowLoginInThisPage } from "@/utils/community.js";
// 创建axios实例并设置拦截器
const axiosInstance = Vue.axios.create();
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // 检查错误响应并判断是否是401未授权错误
    if (error.response && error.response.data.status_code === 401) {
      if (window.location.host.includes("code.xueersi.com")) {
        fnDoShowLoginInThisPage(); // 如果是401错误，执行登录函数
      }
    }
    return Promise.reject(error);
  }
);

export function getLevelMessage(params) {
  return axiosInstance({
    method: "get",
    url: `${url}?v=${new Date().getTime()}`,
  })
    .then((res) => {
      const result = res.data;
      const type = params.type ? params.type : "cpp";
      const config = result[type];
      for (let i = 0; i < config.length; i++) {
        if (Number(config[i].id) === Number(params.level)) {
          config[i].total = config.length;
          return config[i];
        }
      }
    })
    .catch((err) => {
      return err;
    });
}

export function getKeyboardList(params) {
  return axiosInstance
    .get(`${base}/keyboard/getList`, { params })
    .then((res) => res.data);
}

export function getKeyboardDetail(data) {
  return axiosInstance
    .post(`${base}/keyboard/detail`, data)
    .then((res) => res.data);
}

export function finishKeyboard(data) {
  return axiosInstance
    .post(`${base}/keyboard/finish`, data)
    .then((res) => res.data);
}

/**
 * 获取用户信息
 * @returns
 */
export function getUserInfo() {
  return axiosInstance.get(`${base}/user/info`).then((res) => res.data);
}
